import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Snackbar } from '@theswing/rhythm';

import { PageContainer } from '@/components/common/PageContainer';
import { InviteContainer } from './components/InviteContainer';
import IconSwing from '@/assets/images/icon-swing.png';

export function Invite() {  
  const [ isSnackbarVisible, setIsSnackbarVisible ] = useState<boolean>(false);
  const { i18n, t } = useTranslation('taxi');
  const [ query ] = useSearchParams();
  const language = query.get('language') ?? 'ko';
  const code = query.get('code');

  useEffect(() => {
    i18n.changeLanguage(language);

    if (code == null) {
      setIsSnackbarVisible(true);
      setTimeout(() => setIsSnackbarVisible(false), 3600);
      return;
    }

    const link = `https://theswing.onelink.me/bDAE?af_xp=text&pid=deeplink&c=test&af_android_store_csl=com.co.swing&af_dp=theswing%3A%2F%2Fcoupon%2Fadd%3FcouponId%3D${code}&deep_link_value=theswing%3A%2F%2Fcoupon%2Fadd%3FcouponId%3D${code}&is_retargeting=true&af_reengagement_window=1h&af_force_deeplink=true`;
    setTimeout(() => window.location.href = link, 400);
  }, [ i18n, language ]);

  return (
    <PageContainer>
      <PageContainer.GhostNavigationBar />
      <PageContainer.Content>
        <InviteContainer>
          <img src={IconSwing} />
          <section>
            <h1>{t('스윙 앱으로 이동할게요')}</h1>
            <p>{t('잠시만 기다려 주세요')}</p>
          </section>
        </InviteContainer>
      </PageContainer.Content>
      {isSnackbarVisible && (
        <Snackbar animationOptions={{ from: 'top' }}
                  type={'warning'}>
          {t('초대 링크가 올바르지 않습니다')}
        </Snackbar>
      )}
    </PageContainer>
  );
}